import { reactive, readonly, VNode, Component } from 'vue';

export interface ModalButton {
  text: string;
  class?: string;
  onClick: () => void;
}

type ModalContent = string | VNode | Component | (() => VNode);

export interface ModalConfig {
  show: boolean;
  title?: string | VNode;
  content?: ModalContent;
  footer?: VNode | (() => VNode);
  buttons?: ModalButton[];
}

const modalConfig = reactive<ModalConfig>({
  show: false,
  title: '',
  content: '',
  footer: undefined,
  buttons: []
});

export function useModal() {
  const openModal = (config: Partial<Omit<ModalConfig, 'show'>>) => {
    modalConfig.show = true;
    modalConfig.title = config.title ?? '';
    modalConfig.content = config.content ?? '';
    modalConfig.footer = config.footer;
    modalConfig.buttons = config.buttons ?? [];
  };

  const closeModal = () => {
    modalConfig.show = false;
  };

  return {
    modalConfig: readonly(modalConfig),
    openModal,
    closeModal
  };
}
